module.exports = __webpack_public_path__ + "img/img20.22428fa3.svg";